import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Grid, { GridProps } from '@material-ui/core/Grid'
import Button from '../../../../../../control/button/button'

import useButtonSubmittedWithdraw from './useButtonSubmittedWithdraw'
import useTranslate from '../../../../../../i18n/useTranslate'
import useAppFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'

import submittedType from '../../../../../../constants/submittedType'

type ButtonSubmittedWithdrawViewProps = ReturnType<typeof useButtonSubmittedWithdraw> & ButtonSubmittedWithdrawProps
const ButtonSubmittedWithdrawView: React.FC<ButtonSubmittedWithdrawViewProps> = (props) => {
    const { fullWidth, onClickWithdraw } = props
    const classes = useStyles()
    const translate = useTranslate()
    const { folderSelected } = useAppFolderAndTabStore()
    return (
        <Button
            size={'medium'}
            variant="contained"
            onClick={onClickWithdraw}
            className={classes.button}
            fullWidth={fullWidth}
        >
            {folderSelected.submittedTypeID === submittedType.withdrawalSubmitted
                ? translate.get('BUTTON.CANCEL_SUBMITTED_WITHDRAW')
                : translate.get('BUTTON.SUBMITTED_WITHDRAW')}
        </Button>
    )
}

type ButtonSubmittedWithdrawProps = {
    gridProps?: GridProps
    fullWidth?: boolean
}
const ButtonSubmittedWithdraw: React.FC<ButtonSubmittedWithdrawProps> = (props) => {
    const { gridProps = {} } = props
    const model = useButtonSubmittedWithdraw()

    return (
        (model.isShowButton && (
            <Grid item xs={false} {...gridProps}>
                <ButtonSubmittedWithdrawView {...model} {...props} />
            </Grid>
        )) || <></>
    )
}

const useStyles = makeStyles((theme) => ({
    button: {
        border: 'solid 1px #db5f8e',
        backgroundColor: '#ff0000',
        color: 'white',
        marginBottom: 16,
        '&:hover': {
            backgroundColor: '#db0606',
        },
    },
}))
export default ButtonSubmittedWithdraw
